import React from 'react';
import { useGetCareNow } from '~/components/CareTeam/hooks/useGetCareNow';
import { analyticsTrackEvent } from '~/core/analytics';
import { DRAWER_TYPE_COLD_AND_COUGH, NAV_TILE_CLICKED } from '~/core/analytics/events';
import { useTrackNavTile } from '../../hooks/useTrackNavTile';
import { Details, Icon, Root, SubTitle, Title } from '../../styles';
import dataTestIds from '~/test/test-ids';

export const BookColdAndCoughTreatment = () => {
  const goToGetCare = useGetCareNow('uc');

  const onClick = () => {
    goToGetCare();
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      type: DRAWER_TYPE_COLD_AND_COUGH,
    });
  };

  useTrackNavTile(DRAWER_TYPE_COLD_AND_COUGH);

  return (
    <Root onClick={onClick}>
      <Icon alt="Illustration of person coughing" src="/images/account/tiles/cold-new.svg" />
      <Details>
        <Title>Cold & respiratory infection</Title>
        <SubTitle>Get a diagnosis and treatment plan</SubTitle>
      </Details>
    </Root>
  );
};
